// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__WBqM5","footerContent":"Footer_footerContent__CaXEX"};